import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

export const metabolicHealthHeroGradients: Gradient[] = [
  {
    shape: 'ellipse',
    hex: '#FFD67A',
    id: 'top-right-corner',
    position: [98, 10],
    opacity: 0.5,
    size: 25,
  },
  {
    shape: 'circle',
    hex: '#FFD67A',
    id: 'middle-left',
    position: [1, 55],
    opacity: 0.4,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#FBD470',
    id: 'bottom-right-corner',
    position: [90, 75],
    opacity: 0.7,
    size: 40,
  },
];
